import React, { useState, useEffect, useRef, useMemo } from 'react';
import axios from 'axios';
import { API_URL, ENDPOINTS } from '../constants/api';
import '../css/modal.css';
import '../css/autocomplete.css';
import { decodeToken } from '../utils/TokenUtils';
import { useTranslation } from 'react-i18next';
import { notification } from 'antd';
import { fetchForm, loadDropdown, loadInfo,getVisibility } from '../utils/ktcUtils';
import { Link } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

const ModalForm = ({ token, route, queryParams, isOpen, onRequestClose }) => {
  const { t } = useTranslation();
  let queryObj = {};
  // console.log('queryParms:', queryParams);
  if (queryParams) {
    const params = new URLSearchParams(queryParams);
    // console.log("params: ",params);
    queryObj = Object.fromEntries(params.entries());
  }
  // console.log("query object: ",queryObj);
  const [link, setLink] = useState([]);
  const [inputs, setInputs] = useState([]);
  const [values, setValues] = useState([]);
  const [initialValues, setInitialValues] = useState([]);
  const [progress, setProgress] = useState(0);
  const [showPassword, setShowPassword] = useState({});

  const togglePassword = (name) => {
    setShowPassword((prev) => ({
      ...prev,
      [name]: !prev[name],
    }));
  };
  const [message, setMessage] = useState([]);
  const [queries, setQueries] = useState('');

  const branchId = decodeToken(token, 'branch_id');
  const userlevel = decodeToken(token, 'userLevel');

  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [response, setResponse] = useState([]);
  const [childModalOpen, setChildModalOpen] = useState(false);
  const [childRoute, setChildRoute] = useState('');
  const [childQueryParams, setChildQueryParams] = useState(null);

  const visibility = useMemo(() => getVisibility(inputs, values), [inputs, values]);
  const visibleInputs = (inputs || []).filter((i) => visibility[i.name] !== false);

  useEffect(() => {
    const url = `${API_URL}/${ENDPOINTS.SYS}/createform/${route}`;

    fetchForm({
      url,
      queryObj,
      setLink,
      setInputs,
      setValues,
      setLoading,
      setInitialValues,
      isModal: true,
    });
  }, [route]);
  // console.log('values:', values);

  useEffect(() => {
  setValues((prev) => {
    const next = { ...prev };
    let changed = false;
    (inputs || []).forEach((i) => {
      if (visibility[i.name] !== false) return;
      const cur = next[i.name];
      const isEmpty = Array.isArray(cur) ? !cur.length : cur === '' || cur == null;
      if (isEmpty) return;
      next[i.name] = ['checkbox', 'enum-checkbox'].includes(i.type) ? [] : '';
      changed = true;
    });
    return changed ? next : prev;
  });
}, [visibility, inputs]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    //console.log(name, value, type, checked );
    setValues((prevValues) => {
      // update the changed field first
      const newValues = {
        ...prevValues,
        [name]: type === 'checkbox' ? checked : value,
      };

      let updated = true;
      while (updated) {
        updated = false;

        inputs.forEach((inp) => {
          if (inp.options && inp.options.includes('=')) {
            const [target, expression] = inp.options.split('=');
            console.log('options in = ', inp.options);
            // 🛠 Replace variables with values, respecting min_value before eval
            const expr = expression.replace(/\b[a-zA-Z_]\w*\b/g, (match) => {
              let val = newValues[match] ?? 0;

              // If that input has a min_value, clamp it
              const inputMeta = inputs.find((i) => i.name === match);
              if (
                inputMeta &&
                inputMeta.type === 'number' &&
                inputMeta.min_value !== undefined &&
                Number(inputMeta.min_value) > 0
              ) {
                val = Math.max(val, Number(inputMeta.min_value));
              }

              return val;
            });

            try {
              const result = eval(expr) > 0 ? eval(expr) : 0;
              console.log('result: ', result);
              if (newValues[target] !== result) {
                newValues[target] = result;
                updated = true;
              }
            } catch (err) {
              console.warn(
                `Error evaluating formula for ${inp.name}:`,
                expression,
                err
              );
            }
          }
        });
      }

      inputs.forEach((inp) => {
        if (
          inp.type === 'number' &&
          inp.min_value !== undefined &&
          Number(inp.min_value) > 0
        ) {
          const currentVal = Number(newValues[inp.name] ?? 0);
          const minVal = Number(inp.min_value);
          if (currentVal < minVal) {
            newValues[inp.name] = minVal;
          }
        }
      });

      return newValues;
    });

    // console.log('input change e ', e.target);
  };

  const handleLoadDropdownChange = async (e, input) => {
    const { name, value, type, checked } = e.target;

    // console.log('input:', input);

    console.log(name, value, type, checked);
    setValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
    await loadDropdown(
      value, // The event (e.g., from onChange)
      input, // The full input object

      setLoading,
      setValues,
      setInputs
    );
  };

  const handleAutocompleteChange = async (e, inputId) => {
    const { name, value, type, checked } = e.target;

    setQueries((prev) => ({ ...prev, [inputId]: value }));

    //setInputId(inputId);
    // setQuery(value);
    // await fetchSuggestions(
    //   value,
    //   inputId,
    //   token,
    //   setLoading,
    //   setSuggestions,
    //   setResponse
    // );

    fetchSuggestions(value, inputId);
  };

  // Function to fetch suggestions from the server
  const fetchSuggestions = async (query, inputId) => {
    if (!query) {
      setSuggestions((prev) => ({ ...prev, [inputId]: [] }));
      return;
    }
    try {
      setLoading(true);
      const url = `${API_URL}/${ENDPOINTS.SYS}/autocomplete-v2/${inputId}?query=${query}`;
      const response = await axios.get(url, {
        headers: {
          Authorization: token ? `Bearer ${token}` : '',
        },
      });

      // console.log('url:', url, 'response:', response.data);
      setResponse(response.data); // Update suggestions from server response
      setSuggestions((prev) => ({ ...prev, [inputId]: response.data.results }));
    } catch (error) {
      console.error('Error fetching suggestions:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSetClickedValue = async (input, suggestion) => {
    console.log('input:', input, 'suggesion:', suggestion);
    setValues((prevValues) => ({
      ...prevValues,
      [input.name]: suggestion.id,
    }));

    // setQuery(suggestion.name);

    setQueries((prev) => ({ ...prev, [input.id]: suggestion.name }));
    setSuggestions((prev) => ({ ...prev, [input.id]: [] }));
    try {
      await loadDropdown(
        suggestion.id,
        input,
        setLoading,
        setValues,
        setInputs
      );
    } catch (err) {
      notification.error({ message: err.message });
    }
    try {
      await loadInfo(response, input, suggestion, setInputs, setValues);
    } catch (err) {
      notification.error({ message: err.message });
    }
  };

  // console.log('inputs:', inputs);
  // Handle file input changes dynamically
  const handleFileChange = (e) => {
    const { name } = e.target;
    const file = e.target.files[0]; // Get the selected file
    const inp = inputs.find((inp) => inp.name === name);
    console.log('file input: ', inp);
    const maxSizeBytes = inp.max_size_mb * 1024 * 1024;
    if (file.size > maxSizeBytes) {
      notification.error({
        message: `File is too large! Maximum allowed size is ${inp.max_size_mb}MB. Selected file is ${(file.size / (1024 * 1024)).toFixed(2)}MB.`,
      });
      // Clear the input so they can't submit it
      e.target.value = null;

      // Also clear it from your state if you store files in state
      setValues((prev) => ({
        ...prev,
        [inp.name]: null,
      }));
      return;
    }

    setValues((prev) => ({
      ...prev,
      [name]: file, // Dynamically set the file input field by name
    }));
  };

  const handleMultiFileChange = (e) => {
    const { name } = e.target;
    const files = Array.from(e.target.files); // Convert FileList to array

    setValues((prev) => ({
      ...prev,
      [name]: files, // Store array of files for the input field
    }));
  };

  //console.log('insert route:', `${API_URL}/${ENDPOINTS.SYS}/create/${route}`)

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setProgress(0);

    // Create a copy of formData without the clearAfterSubmit field
    const { clearAfterSubmit, ...values2 } = values;

    try {
      const route2 = route.replace(/^\s+|\s+$/g, ''); // Trims leading and trailing spaces
      //  console.log('route: "', route, '", route2: "', route2, '"');
      var insertUrl = `${API_URL}/${ENDPOINTS.SYS}/create/${route}`;
      if (
        link.api_route &&
        link.api_route !== '' &&
        link.api_route.trim() !== ''
      ) {
        insertUrl = `${API_URL}/${link.api_route}`;
        // link.form_type = 'reg-upload-modal'; // to send to upload for test only
      } else if (
        link.form_type === 'reg-upload-modal' &&
        link.sql_query &&
        link.sql_query.trim() !== ''
      ) {
        insertUrl = `${API_URL}/${ENDPOINTS.SYS}/create-upload-custom/${route}`;
      } else if (link.form_type === 'reg-upload-modal') {
        insertUrl = `${API_URL}/${ENDPOINTS.SYS}/create-upload/${route}`;
      }
      // console.log('insert route:', insertUrl, 'values:', values);

      const data = new FormData();

      // Append all fields (including files) to FormData
      // Object.keys(values2).forEach((key) => {
      //   data.append(key, values2[key]); // Appends both files and text fields dynamically
      // });

      // Append all fields (including files) to FormData
      Object.keys(values2).forEach((key) => {
        const value = values2[key];

        if (Array.isArray(value)) {
          value.forEach((file) => {
            data.append(key, file); // ✅ No square brackets
          });
        } else {
          data.append(key, value);
        }
      });

      try {
        // console.log('values2:', values2);
        var response;
        if (link.form_type === 'reg-upload-modal') {
          if (userlevel === 'developer') {
            console.log('data:', data.entries());
          }

          response = await axios.post(insertUrl, data, {
            headers: {
              'Content-Type': 'multipart/form-data', // Required for FormData
              Authorization: token ? `Bearer ${token}` : '',
            },
            onUploadProgress: (progressEvent) => {
              const percent = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              setProgress(percent);
            },
          });
          if (userlevel === 'developer') {
            console.log('res:', response);
          }
          //  console.log();
        } else {
          response = await axios.post(insertUrl, values2, {
            headers: {
              Authorization: token ? `Bearer ${token}` : '',
            },
          });
        }
        // print console url, request and response

        if (userlevel === 'developer') {
          console.log(
            'url:',
            insertUrl,
            'request:',
            values2,
            'reponse:',
            response.data
          );
        }
        console.log('message holds: ', response.data);
        setMessage(response.data);
        setLoading(false);
        setProgress(0);

        if (response.data.success === '1' || response.data.success === 1) {
          // Clear form only if checkbox is checked
          if (clearAfterSubmit) {
            setValues(initialValues);
            setQueries('');
          }
          if (
            response.data.insertId &&
            response.data.print_route &&
            response.data.insertId !== '0' &&
            response.data.print_route !== '0'
          ) {
            console.log('Show success & print button');
            const printUrl = `/${response.data.print_route}/${response.data.insertId}`;
            console.log('url:  to print ', printUrl);
            window.open(printUrl, '_blank');
            if (link.auto_submit === '1' || link.auto_submit === 1) {
              notification.success({ message: response.data.message });
              console.log('close the modal');
              onRequestClose(); // Close modal after submission
            }
          } else {
            if (link.auto_submit === '1' || link.auto_submit === 1) {
              notification.success({ message: response.data.message });
              console.log('close the modal');
              onRequestClose(); // Close modal after submission
            }
          }
        }

        // onRequestClose(); // Close modal after submission
      } catch (error) {
        alert(`An error occurred ${error.message}`);
        // console.log('error:', error, 'insertUrl:',insertUrl, 'values:', values);
        setLoading(false);
        setProgress(0);
      }
    } catch (error) {
      alert(`An error occurred ${error.message}`);
      setLoading(false);
      setProgress(0);
    }
  };

  // console.log('link:', link);
  // console.log('inputs:', inputs);
  //console.log('message:', message);

  const pdfRef = useRef();

  const exportPDF = async () => {
    const element = pdfRef.current; // Target container (modal-body or form)
    if (!element) return;

    // 1. Create a deep clone of the element to sanitize it safely behind the scenes
    const printClone = element.cloneNode(true);

    // Apply temporary high-fidelity printable styling to the clone
    printClone.style.cssText = `
    position: absolute !important;
    top: -9999px !important; /* Hide it far off-screen from the user */
    left: -9999px !important;
    width: 800px !important; /* Fixed crisp width for A4 page ratio */
    height: auto !important;
    background: #ffffff !important;
    padding: 30px !important;
    box-sizing: border-box !important;
    overflow: visible !important;
  `;
    document.body.appendChild(printClone);

    // 2. Sanitize and prepare form elements for high-quality physical printing
    const inputs = printClone.querySelectorAll('input, textarea, select');
    inputs.forEach((input) => {
      const parent = input.parentElement;
      const value = input.value ? input.value.trim() : '';

      // A. Handle file uploads (e.g., Student Image)
      if (input.type === 'file') {
        // Create a clean, elegant Passport Photo frame for the paper printout
        const photoBox = document.createElement('div');
        photoBox.className =
          'd-flex align-items-center justify-content-center text-muted';
        photoBox.style.cssText = `
        width: 120px;
        height: 150px;
        border: 2px dashed #cbd5e1;
        border-radius: 8px;
        background-color: #f8fafc;
        font-size: 0.8rem;
        font-weight: 500;
        text-align: center;
        margin-top: 8px;
      `;
        photoBox.innerHTML = 'Paste Passport<br/>Photo Here';

        // Replace file picker instructions with the neat physical box
        if (parent) {
          parent.innerHTML = '';
          parent.appendChild(photoBox);
        }
        return;
      }

      // B. Handle Checkboxes and Radios
      if (input.type === 'checkbox' || input.type === 'radio') {
        const originalInput = element.querySelector(
          `[id="${input.id}"], [name="${input.name}"][value="${input.value}"]`
        );
        if (originalInput && originalInput.checked) {
          input.setAttribute('checked', 'checked');
          input.style.accentColor = '#000000';
        } else {
          input.removeAttribute('checked');
        }
        return;
      }

      // C. Handle Selects/Dropdowns
      if (input.tagName.toLowerCase() === 'select') {
        const selectedText = input.options[input.selectedIndex]?.text || '';
        const isPlaceholderOption =
          selectedText.toLowerCase().includes('select') || selectedText === '';

        const textReplacement = document.createElement('div');
        textReplacement.className = 'form-control-print-replacement';

        if (isPlaceholderOption) {
          // If nothing is selected, create a clean writing line
          textReplacement.style.cssText = `
          border-bottom: 1px solid #94a3b8 !important;
          height: 30px;
          width: 100%;
          margin-top: 4px;
        `;
        } else {
          // If a value is selected, write it out cleanly
          textReplacement.style.cssText = `
          border-bottom: 1px solid #e2e8f0 !important;
          font-size: 0.9rem;
          padding: 4px 0;
          color: #0f172a;
          font-weight: 500;
        `;
          textReplacement.textContent = selectedText;
        }

        if (parent) {
          parent.replaceChild(textReplacement, input);
        }
        return;
      }

      // D. Handle Text, Textareas, and Dates
      if (
        input.type === 'text' ||
        input.tagName.toLowerCase() === 'textarea' ||
        input.type === 'date' ||
        input.type === 'number'
      ) {
        // Fetch dynamic live value from the actual active DOM
        const liveInput = element.querySelector(
          `[id="${input.id}"], [name="${input.name}"]`
        );
        const liveValue = liveInput ? liveInput.value : value;

        const textReplacement = document.createElement('div');
        textReplacement.className = 'form-control-print-replacement';

        if (!liveValue) {
          // No input filled? Make it a clean writing line with NO placeholder text blocking the pen
          textReplacement.style.cssText = `
          border-bottom: 1px solid #94a3b8 !important;
          height: 30px;
          width: 100%;
          margin-top: 4px;
        `;
        } else {
          // Filled input? Display the text cleanly as high-contrast print
          textReplacement.style.cssText = `
          border-bottom: 1px solid #e2e8f0 !important;
          font-size: 0.9rem;
          padding: 4px 0;
          color: #0f172a;
          font-weight: 500;
          word-break: break-word;
        `;
          textReplacement.textContent = liveValue;
        }

        if (parent) {
          parent.replaceChild(textReplacement, input);
        }
      }
    });

    // Remove elements that don't belong on a printable form (buttons, add-on icons, progress bars, etc.)
    const interactiveButtons = printClone.querySelectorAll(
      'button, .btn, .spinner-border, .progress, .alert'
    );
    interactiveButtons.forEach((btn) => btn.remove());

    try {
      // 3. Render high-fidelity canvas from the isolated clone
      const canvas = await html2canvas(printClone, {
        scale: 2.5, // Ultra-sharp contrast for physical paper printing
        useCORS: true,
        logging: false,
        backgroundColor: '#ffffff',
      });

      // Remove the hidden clone immediately after capturing the snapshot
      document.body.removeChild(printClone);

      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4');

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
      const pageHeight = pdf.internal.pageSize.getHeight();

      let heightLeft = pdfHeight;
      let position = 0;
      let pageCount = 0;

      // Output first page
      pdf.addImage(imgData, 'PNG', 0, position, pdfWidth, pdfHeight);
      heightLeft -= pageHeight;

      // Loop elegantly through multiple pages without scaling drift or cut-offs
      while (heightLeft > 0) {
        pageCount++;
        position = -(pageHeight * pageCount);
        pdf.addPage();
        pdf.addImage(imgData, 'PNG', 0, position, pdfWidth, pdfHeight);
        heightLeft -= pageHeight;
      }

      pdf.save(`${link?.name || 'form-export'}.pdf`);
    } catch (error) {
      console.error('Error exporting clean PDF:', error);
      // Cleanup protection in case canvas fails
      if (document.body.contains(printClone)) {
        document.body.removeChild(printClone);
      }
    }
  };
  return (
    <div
      className={`modal fade ${isOpen ? 'show' : ''}`}
      style={{
        display: isOpen ? 'block' : 'none',
        backgroundColor: isOpen ? 'rgba(15, 23, 42, 0.3)' : 'transparent',
        backdropFilter: 'none',
        transition: 'all 0.3s ease',
      }}
      tabIndex="-1"
      aria-hidden={isOpen ? 'false' : 'true'}
    >
      <div
        className={`modal-dialog ${inputs.length > 15 ? 'modal-xl' : 'modal-lg'} modal-dialog-centered`}
        ref={pdfRef}
        style={{
          maxHeight: '90vh',
          overflowY: 'auto',
        }}
      >
        <div
          className="modal-content border-0 shadow-lg"
          style={{ borderRadius: '16px', overflow: 'hidden' }}
        >
          {/* Modal Header */}
          <div className="modal-header border-bottom border-light px-4 py-3 align-items-center bg-light">
            <div>
              <h5
                className="modal-title fw-bold text-dark mb-0 fs-5"
                style={{ letterSpacing: '-0.025em' }}
              >
                {link?.name}
              </h5>
              {(link?.category || link?.sub_category) && (
                <span className="badge bg-light text-muted fw-semibold mt-1 py-1.5 px-2.5 fs-7 border border-1">
                  {link?.category}{' '}
                  {link?.sub_category ? `→ ${link?.sub_category}` : ''}
                </span>
              )}
            </div>

            <button
              type="button"
              className="btn-close shadow-none"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={onRequestClose}
              style={{ fontSize: '0.85rem' }}
            ></button>
          </div>

          {/* Print / Utility Toolbar */}
          {/* <div className="px-4 py-2 bg-light-subtle d-flex justify-content-end border-bottom border-light">
          <button 
            type="button"
            onClick={exportPDF} 
            className="btn btn-sm btn-outline-secondary d-flex align-items-center gap-2 px-3 py-1.5"
            style={{ borderRadius: '8px', fontSize: '0.85rem', fontWeight: '500' }}
          >
            <FeatherIcon icon="printer" size={14} />
            Print Form
          </button>
        </div> */}

          {/* Modal Body */}
          <div
            className="modal-body p-4"
            style={{ maxHeight: '80vh', overflowY: 'auto' }}
          >
            <form onSubmit={handleSubmit} encType="multipart/form-data">
              <div className="row g-4">
                {visibleInputs &&
                  visibleInputs.map((input) => {
                    const options =
                      input.options
                        ?.split(',')
                        .map((option) => option.trim()) || [];

                    return (
                      <div
                        className={`col-${input.size} ${input.type.includes('hidden') ? 'd-none' : ''}`}
                        key={input.name}
                      >
                        {input.type !== 'hidden-user' &&
                          input.type !== 'hidden' &&
                          input.type !== 'hidden-branch' && (
                            <div className="d-flex align-items-center justify-content-between mb-2">
                              <label
                                htmlFor={input.name}
                                className="form-label fw-semibold text-secondary mb-0"
                                style={{
                                  fontSize: '0.9rem',
                                  letterSpacing: '0.2px',
                                }}
                              >
                                {t(input.label)}
                                {input.is_required !== 0 && (
                                  <span
                                    className="text-danger ms-1"
                                    title={`'${input.label}' field is required, please fill it before submitting the form`}
                                  >
                                    *
                                  </span>
                                )}
                              </label>

                              {/* Help & Add-on Actions */}
                              <div className="d-flex align-items-center gap-2">
                                {input.is_required !== 0 &&
                                  input.description && (
                                    <span
                                      className="d-inline-flex align-items-center justify-content-center text-white bg-danger-subtle text-danger"
                                      style={{
                                        width: '18px',
                                        height: '18px',
                                        borderRadius: '50%',
                                        fontSize: '0.7rem',
                                        cursor: 'help',
                                        fontWeight: 'bold',
                                      }}
                                      title={`${input.description} ${input.help || ''}`}
                                    >
                                      ?
                                    </span>
                                  )}
                                {
                                  (input?.reg_route || '').trim() && (
                                    <button
                                      type="button"
                                      style={{
                                        background: 'none',
                                        border: 'none',
                                      }}
                                      className="text-primary p-0 d-flex align-items-center hover-opacity"
                                      onClick={() => {
                                        setChildRoute(input.reg_route);
                                        setChildQueryParams(null);
                                        setChildModalOpen(true);
                                      }}
                                    >
                                      <FeatherIcon icon={'plus'} size={18} />
                                    </button>
                                  )}
                              </div>
                            </div>
                          )}

                        {/* Inputs Rendering Engine */}
                        {(() => {
                          switch (input.type) {
                            case 'radio':
                              return (
                                <div className="d-flex flex-wrap gap-3 pt-1">
                                  {input.dynamic_options &&
                                    input.dynamic_options.map(
                                      (option, index) => (
                                        <div className="form-check" key={index}>
                                          <input
                                            type="radio"
                                            className="form-check-input"
                                            id={`${input.name}-${index}`}
                                            name={input.name}
                                            value={option.id}
                                            checked={
                                              values[input.name] === option.id
                                            }
                                            onChange={handleChange}
                                          />
                                          <label
                                            htmlFor={`${input.name}-${index}`}
                                            className="form-check-label text-dark fs-7"
                                          >
                                            {option.name}
                                          </label>
                                        </div>
                                      )
                                    )}
                                </div>
                              );

                            case 'dropdown':
                              return (
                                <select
                                  className="form-select border-light-subtle shadow-sm px-3 py-2"
                                  style={{
                                    borderRadius: '8px',
                                    fontSize: '0.9rem',
                                  }}
                                  id={input.name}
                                  name={input.name}
                                  value={values[input.name]}
                                  onChange={handleChange}
                                  required={input.is_required}
                                >
                                  <option value="">Select an option</option>
                                  {input.dynamic_options &&
                                    (() => {
                                      const hasGroup =
                                        input.dynamic_options.some(
                                          (opt) => opt.group
                                        );

                                      if (hasGroup) {
                                        const grouped =
                                          input.dynamic_options.reduce(
                                            (acc, opt) => {
                                              const groupName =
                                                opt.group || 'Ungrouped';
                                              if (!acc[groupName])
                                                acc[groupName] = [];
                                              acc[groupName].push(opt);
                                              return acc;
                                            },
                                            {}
                                          );

                                        return Object.entries(grouped).map(
                                          ([group, options]) => (
                                            <optgroup key={group} label={group}>
                                              {options.map((opt) => (
                                                <option
                                                  key={opt.id}
                                                  value={opt.id}
                                                >
                                                  {opt.name}
                                                </option>
                                              ))}
                                            </optgroup>
                                          )
                                        );
                                      } else {
                                        return input.dynamic_options.map(
                                          (option, index) => {
                                            const optionKeys =
                                              Object.keys(option);
                                            const firstValue =
                                              option[optionKeys[0]] ||
                                              'No Value 1';
                                            const secondValue =
                                              option[optionKeys[1]] ||
                                              'No Value 2';
                                            return (
                                              <option
                                                key={index}
                                                value={firstValue}
                                              >
                                                {secondValue}
                                              </option>
                                            );
                                          }
                                        );
                                      }
                                    })()}
                                </select>
                              );

                            case 'group-dropdown':
                              return (
                                <select
                                  className="form-select border-light-subtle shadow-sm px-3 py-2"
                                  style={{
                                    borderRadius: '8px',
                                    fontSize: '0.9rem',
                                  }}
                                  id={input.name}
                                  name={input.name}
                                  value={values[input.name]}
                                  onChange={handleChange}
                                  required={input.is_required}
                                >
                                  <option value="">Select an option</option>
                                  {input.dynamic_options &&
                                    Object.entries(
                                      input.dynamic_options.reduce(
                                        (groups, option) => {
                                          if (!groups[option.group])
                                            groups[option.group] = [];
                                          groups[option.group].push(option);
                                          return groups;
                                        },
                                        {}
                                      )
                                    ).map(([group, options]) => (
                                      <optgroup key={group} label={group}>
                                        {options.map((option) => (
                                          <option
                                            key={option.id}
                                            value={option.id}
                                          >
                                            {option.name}
                                          </option>
                                        ))}
                                      </optgroup>
                                    ))}
                                </select>
                              );

                            case 'load-dropdown':
                            case 'load-dropdown2':
                            case 'load-input':
                              return (
                                <select
                                  className="form-select border-light-subtle shadow-sm px-3 py-2"
                                  style={{
                                    borderRadius: '8px',
                                    fontSize: '0.9rem',
                                  }}
                                  id={input.name}
                                  name={input.name}
                                  value={values[input.name]}
                                  onChange={(e) =>
                                    handleLoadDropdownChange(e, input)
                                  }
                                  required={input.is_required}
                                >
                                  <option value="%">Select all</option>
                                  {input.dynamic_options?.map(
                                    (option, index) => {
                                      const optionKeys = Object.keys(option);
                                      const firstValue =
                                        option[optionKeys[0]] || 'No Value 1';
                                      const secondValue =
                                        option[optionKeys[1]] || 'No Value 2';
                                      return (
                                        <option key={index} value={firstValue}>
                                          {secondValue}
                                        </option>
                                      );
                                    }
                                  )}
                                </select>
                              );

                            case 'autocomplete':
                              return (
                                <div className="position-relative">
                                  <input
                                    type="text"
                                    className="form-control border-light-subtle shadow-sm px-3 py-2"
                                    style={{
                                      borderRadius: '8px',
                                      fontSize: '0.9rem',
                                    }}
                                    value={queries[input.id] || ''}
                                    onChange={(e) =>
                                      handleAutocompleteChange(e, input.id)
                                    }
                                    placeholder="Search..."
                                  />
                                  {loading && (
                                    <div className="position-absolute end-0 top-50 translate-middle-y pe-3">
                                      <div
                                        className="spinner-border spinner-border-sm text-secondary"
                                        role="status"
                                      ></div>
                                    </div>
                                  )}
                                  {suggestions[input.id]?.length > 0 && (
                                    <ul
                                      className="list-group position-absolute shadow-lg border border-light-subtle mt-1"
                                      style={{
                                        margin: 0,
                                        top: '100%',
                                        width: '100%',
                                        zIndex: 1050,
                                        maxHeight: '200px',
                                        overflowY: 'auto',
                                        borderRadius: '8px',
                                        backgroundColor: '#fff',
                                      }}
                                    >
                                      {suggestions[input.id].map(
                                        (suggestion, index) => (
                                          <li
                                            className="list-group-item list-group-item-action border-0 px-3 py-2 fs-7"
                                            key={index}
                                            onClick={() =>
                                              handleSetClickedValue(
                                                input,
                                                suggestion
                                              )
                                            }
                                            style={{
                                              cursor: 'pointer',
                                              fontSize: '0.875rem',
                                            }}
                                          >
                                            {suggestion.name}
                                          </li>
                                        )
                                      )}
                                    </ul>
                                  )}
                                  {/* {input?.loadInfo && (
                                    <p className="text-muted fs-7 mt-1 mb-0">
                                      {input.loadInfo}
                                    </p>
                                  )} */}
                                </div>
                              );

                            case 'enum':
                              return (
                                <div className="d-flex flex-wrap gap-3 pt-1">
                                  {options &&
                                    options.map((option, index) => (
                                      <div
                                        className="form-check form-check-inline"
                                        key={index}
                                      >
                                        <input
                                          type="radio"
                                          className="form-check-input"
                                          id={`${input.name}-${index}`}
                                          name={input.name}
                                          value={option}
                                          checked={
                                            values[input.name] === option
                                          }
                                          onChange={handleChange}
                                        />
                                        <label
                                          htmlFor={`${input.name}-${index}`}
                                          className="form-check-label fs-7"
                                        >
                                          {option}
                                        </label>
                                      </div>
                                    ))}
                                </div>
                              );

                            case 'enum-checkbox':
                              return (
                                <div className="d-flex flex-column gap-2 pt-1">
                                  {options?.map((option, index) => (
                                    <div className="form-check" key={index}>
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id={`${input.name}-${index}`}
                                        name={input.name}
                                        value={option}
                                        checked={values[input.name]?.includes(
                                          option
                                        )}
                                        onChange={(e) => {
                                          const isChecked = e.target.checked;
                                          const currentValues =
                                            values[input.name] || [];
                                          const updatedValues = isChecked
                                            ? [...currentValues, option]
                                            : currentValues.filter(
                                                (val) => val !== option
                                              );

                                          handleChange({
                                            target: {
                                              name: input.name,
                                              value: updatedValues,
                                            },
                                          });
                                        }}
                                      />
                                      <label
                                        htmlFor={`${input.name}-${index}`}
                                        className="form-check-label fs-7"
                                      >
                                        {option}
                                      </label>
                                    </div>
                                  ))}
                                </div>
                              );

                            case 'enum-dropdown':
                              return (
                                <select
                                  className="form-select border-light-subtle shadow-sm px-3 py-2"
                                  style={{
                                    borderRadius: '8px',
                                    fontSize: '0.9rem',
                                  }}
                                  id={input.name}
                                  name={input.name}
                                  onChange={handleChange}
                                  required={input.is_required}
                                >
                                  <option value="">Select an option</option>
                                  {options &&
                                    options.map((option, index) => (
                                      <option key={index} value={option}>
                                        {option}
                                      </option>
                                    ))}
                                </select>
                              );

                            case 'checkbox':
                              return (
                                <div className="p-3 bg-light rounded-3 border border-light-subtle">
                                  {input.dynamic_options?.length > 0 && (
                                    <div className="form-check mb-2 pb-2 border-bottom border-light">
                                      <input
  type="checkbox"
  className="form-check-input"
  id={`${input.name}-check-all`}
  checked={
    input.dynamic_options.length > 0 &&
    (values[input.name] || []).length === input.dynamic_options.length
  }
  onChange={(e) => {
    const isChecked = e.target.checked;

    const allIds = input.dynamic_options.map((opt) =>
      String(opt.id)
    );

    handleChange({
      target: {
        name: input.name,
        value: isChecked ? allIds : [],
      },
    });
  }}
/>
                                      <label
                                        htmlFor={`${input.name}-check-all`}
                                        className="form-check-label fw-bold text-dark fs-7"
                                      >
                                        Check All
                                      </label>
                                    </div>
                                  )}

                                  <div className="d-flex flex-wrap gap-x-4 gap-y-2">
                                    {input.dynamic_options &&
                                      input.dynamic_options.map(
                                        (option, index) => (
                                          <div
                                            className="form-check form-check-inline"
                                            key={index}
                                          >
                                            {/* <input
                                              type="checkbox"
                                              className="form-check-input"
                                              id={`${input.name}-${index}`}
                                              name={input.name}
                                              value={option.id}
                                              checked={values[
                                                input.name
                                              ]?.includes(option.id)}
                                              onChange={(e) => {
                                                const isChecked =
                                                  e.target.checked;
                                                const value = option.id;
                                                const currentValues =
                                                  values[input.name] || [];
                                                  console.log("current values: ",currentValues);
                                                const updatedValues = isChecked
                                                  ? [...currentValues, value]
                                                  : currentValues.filter(
                                                      (v) => v !== value
                                                    );

                                                handleChange({
                                                  target: {
                                                    name: input.name,
                                                    value: updatedValues,
                                                  },
                                                });
                                              }}
                                            /> */}
                                            <input
  type="checkbox"
  className="form-check-input"
  id={`${input.name}-${option.id}`}
  name={input.name}
  value={String(option.id)}
  checked={(values[input.name] || []).includes(String(option.id))}
  onChange={(e) => {
    const value = String(option.id);
    const currentValues = values[input.name] || [];

    const updatedValues = e.target.checked
      ? [...currentValues, value]
      : currentValues.filter((v) => v !== value);

    handleChange({
      target: {
        name: input.name,
        value: updatedValues,
      },
    });
  }}
/>
                                            <label
                                              htmlFor={`${input.name}-${index}`}
                                              className="form-check-label fs-7"
                                            >
                                              {option.name}
                                            </label>
                                          </div>
                                        )
                                      )}
                                  </div>
                                </div>
                              );

                            case 'hidden-user':
                            case 'hidden-branch':
                              return (
                                <input
                                  type="hidden"
                                  id={input.name}
                                  name={input.name}
                                  value="0"
                                  required={input.is_required}
                                />
                              );

                            case 'textarea':
                              return (
                                <textarea
                                  className="form-control border-light-subtle shadow-sm px-3 py-2"
                                  style={{
                                    borderRadius: '8px',
                                    fontSize: '0.9rem',
                                  }}
                                  id={input.name}
                                  name={input.name}
                                  rows="3"
                                  value={values[input.name]}
                                  onChange={handleChange}
                                  required={input.is_required}
                                ></textarea>
                              );

                            case 'file':
                            case 'multi-file':
                              return (
                                <div className="p-2 bg-light border border-dashed rounded-3">
                                  {/* <FeatherIcon icon="upload-cloud" size={24} className="text-muted mb-2" /> */}
                                  <input
                                    title="file"
                                    type="file"
                                    multiple={input.type === 'multi-file'}
                                    className="form-control shadow-sm"
                                    id={input.name}
                                    name={input.name}
                                    placeholder={input.placeholder}
                                    onChange={
                                      input.type === 'multi-file'
                                        ? handleMultiFileChange
                                        : handleFileChange
                                    }
                                    required={input.is_required}
                                    accept={input.allowed_extensions}
                                    style={{ maxWidth: '280px' }}
                                  />
                                  <p className="text-muted fs-7 mb-0 mt-2">
                                    Allowed formats:{' '}
                                    <strong className="text-dark">
                                      {input.allowed_extensions}
                                    </strong>{' '}
                                    • Max size:{' '}
                                    <strong className="text-dark">
                                      {input.max_size_mb}MB
                                    </strong>
                                  </p>
                                </div>
                              );

                            case 'today-date':
                              return (
                                <input
                                  title="Today date, can't change the date"
                                  type={input.type}
                                  className="form-control border-light-subtle shadow-sm px-3 py-2 bg-light text-muted fw-medium"
                                  style={{
                                    borderRadius: '8px',
                                    fontSize: '0.9rem',
                                  }}
                                  id={input.name}
                                  name={input.name}
                                  placeholder={input.placeholder}
                                  value={values[input.name]}
                                  onChange={handleChange}
                                  required={input.is_required}
                                  readOnly={true}
                                />
                              );

                            case 'password':
                              return (
                                <div className="position-relative">
                                  <input
                                    type={
                                      showPassword[input.name]
                                        ? 'text'
                                        : 'password'
                                    }
                                    className="form-control border-light-subtle shadow-sm px-3 py-2 pe-5"
                                    style={{
                                      borderRadius: '8px',
                                      fontSize: '0.9rem',
                                    }}
                                    id={input.name}
                                    name={input.name}
                                    placeholder={input.placeholder}
                                    value={values[input.name]}
                                    onChange={handleChange}
                                    required={input.is_required}
                                    readOnly={input.is_readonly}
                                  />
                                  <button
                                    type="button"
                                    onClick={() => togglePassword(input.name)}
                                    className="btn btn-link position-absolute end-0 top-50 translate-middle-y pe-3 text-secondary text-decoration-none fw-semibold"
                                    style={{ fontSize: '0.8rem' }}
                                  >
                                    {showPassword[input.name] ? 'Hide' : 'Show'}
                                  </button>
                                </div>
                              );

                            default:
                              return (
                                <input
                                  type={input.type}
                                  className="form-control border-light-subtle shadow-sm px-3 py-2"
                                  style={{
                                    borderRadius: '8px',
                                    fontSize: '0.9rem',
                                  }}
                                  id={input.name}
                                  name={input.name}
                                  placeholder={input.placeholder}
                                  value={values[input.name]}
                                  onChange={handleChange}
                                  required={input.is_required}
                                  readOnly={input.is_readonly}
                                  onKeyDown={
                                    input.type === 'date' &&
                                    ((input.min_value?.trim() || '') !== '' ||
                                      (input.max_value?.trim() || '') !== '')
                                      ? (e) => e.preventDefault()
                                      : undefined
                                  }
                                />
                              );
                          }
                        })()}
                        {input.help && (
                          <p className="text-muted fs-7 mt-1.5 mb-0 d-flex align-items-center gap-1">
                            <FeatherIcon
                              icon="info"
                              size={12}
                              className="text-info"
                            />
                            {input.help}
                          </p>
                        )}
                      </div>
                    );
                  })}

                {/* Form Footer & Controls */}
                <div className="col-12 border-top border-light pt-4 mt-4">
                  <div className="d-flex flex-column flex-sm-row justify-content-between align-items-center gap-3">
                    {/* Clear After Submit Toggle */}
                    <div className="form-check form-switch mb-0">
                      <input
                        type="checkbox"
                        name="clearAfterSubmit"
                        id="clearAfterSubmit"
                        checked={values.clearAfterSubmit}
                        onChange={handleChange}
                        className="form-check-input cursor-pointer"
                        style={{ width: '2.5em', height: '1.25em' }}
                      />
                      <label
                        className="form-check-label text-secondary fw-medium ms-2 cursor-pointer"
                        htmlFor="clearAfterSubmit"
                        style={{ fontSize: '0.9rem', whiteSpace: 'nowrap' }}
                      >
                        Clear after submit
                      </label>
                    </div>

                    {/* Actions Group */}
                    <div className="d-flex gap-2 w-100 w-sm-auto justify-content-end">
                      {route && route === 'change-password' && (
                        <Link
                          className="btn btn-outline-danger px-4 py-2 fw-medium"
                          style={{ borderRadius: '8px', fontSize: '0.9rem' }}
                          to={'/'}
                        >
                          Re-login
                        </Link>
                      )}
                      <button
                        type="submit"
                        className="btn btn-primary px-4 py-2 fw-semibold shadow-sm d-flex align-items-center gap-2"
                        style={{ borderRadius: '8px', fontSize: '0.9rem' }}
                        disabled={loading}
                      >
                        {loading && (
                          <div
                            className="spinner-border spinner-border-sm text-white"
                            role="status"
                          ></div>
                        )}
                        {loading
                          ? 'Uploading...'
                          : link.button
                            ? link.button
                            : 'Submit'}
                      </button>
                    </div>
                  </div>
                </div>

                {/* Progress Bar & Alert Handlers */}
                {progress > 0 && (
                  <div className="col-12 mt-3">
                    <div className="d-flex justify-content-between align-items-center mb-1">
                      <span className="text-secondary fw-semibold fs-7">
                        Progress
                      </span>
                      <span className="text-dark fw-bold fs-7">
                        {progress}%
                      </span>
                    </div>
                    <div
                      className="progress"
                      style={{ height: '8px', borderRadius: '4px' }}
                    >
                      <div
                        className="progress-bar bg-success progress-bar-striped progress-bar-animated"
                        role="progressbar"
                        style={{ width: `${progress}%` }}
                        aria-valuenow={progress}
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>
                  </div>
                )}

                {message.success == 0 && (
                  <div className="col-12 mt-3">
                    <div
                      className="alert alert-danger border-0 d-flex align-items-center gap-2 mb-0 shadow-sm"
                      role="alert"
                      style={{ borderRadius: '8px' }}
                    >
                      <FeatherIcon icon="alert-circle" size={18} />
                      <div className="fw-medium">{message.message}</div>
                    </div>
                  </div>
                )}

                {message.success == 1 && (
                  <div className="col-12 mt-3">
                    <div
                      className="alert alert-success border-0 d-flex align-items-center justify-content-between mb-0 shadow-sm"
                      role="alert"
                      style={{ borderRadius: '8px' }}
                    >
                      <div className="d-flex align-items-center gap-2">
                        <FeatherIcon icon="check-circle" size={18} />
                        <span className="fw-medium">{message.message}</span>
                      </div>
                      {message.insertId &&
                        message.print_route &&
                        message.insertId !== '0' &&
                        message.print_route !== '0' && (
                          <a
                            href={`/${message.print_route}/${message.insertId}`}
                            target="_blank"
                            rel="noreferrer"
                            className="btn btn-sm btn-success px-3"
                            style={{ borderRadius: '6px' }}
                          >
                            Print
                          </a>
                        )}
                    </div>
                  </div>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Child Modal Form */}
      {childModalOpen && (
        <ModalForm
          token={token}
          route={childRoute}
          queryParams={childQueryParams}
          isOpen={childModalOpen}
          onRequestClose={() => setChildModalOpen(false)}
        />
      )}
    </div>
  );
};

export default ModalForm;
